export enum mergePDFType{
    MANIFEST = "MANIFEST",
    LABEL = "LABEL"
}

export type PdfParameters={
    filename:String,
    isCancelled:Boolean
}